/**
 * XPEN-3225: picking a matter on a line defaults that line's Attorney to the
 * matter's responsible attorney, instead of leaving the user to choose it.
 *
 * The value is the raw ERP attorney code carried by `/matters/search/`, which
 * is the same value space as the Attorney picker and the SurePoint export's
 * Cost Attorney Number column. It is not `user_responsible` — that one is an
 * XPENS user id, and an attorney need not be an XPENS user at all.
 */

// Mirrors the marker `updateInvoice` writes when it sets a field itself
// (invoice.js). Writing the whole line item skips that branch, so the status
// has to be carried here or the line would look untouched.
const FIELD_UPDATE_STATUS = 4;

/** The attorney code on a line, whether it is stored as a picker option or a bare code. */
export const lineAttorneyCode = (item) => {
    const own = item?.AttorneyId;
    const code = typeof own === 'object' ? own?.value : own;
    return code == null ? '' : String(code).trim();
};

/**
 * The line item as it should be after a matter is chosen.
 *
 * `matter` is the row from `/matters/search/` when the user picked a
 * suggestion, and null when they typed a number the caller has not resolved —
 * in which case only the matter number is written and the Attorney is left
 * alone. An Attorney the user already set is never overwritten.
 */
export const withMatterAttorneyDefault = ({ item, matterId, matter, showAttorney }) => {
    const updatedItem = {
        ...item,
        MatterId: matterId ?? '',
        MatterIdStatus: FIELD_UPDATE_STATUS,
    };

    if (!showAttorney) return updatedItem;

    const code = matter?.responsible_attorney;
    const normalized = code == null ? '' : String(code).trim();
    if (!normalized) return updatedItem;

    if (lineAttorneyCode(item)) return updatedItem;

    return {
        ...updatedItem,
        AttorneyId: normalized,
        AttorneyIdStatus: FIELD_UPDATE_STATUS,
    };
};
